import React, { useEffect, useState } from 'react';
import VideoModal from '../components/VideoModal'
import dlpimg from '../assets/images/data-loss-prevention.webp'
import sync from '../assets/images/Vectorsync.png'
import social from '../assets/images/Vectorsocial.png'
import selfService from '../assets/images/VectorselfService.png'
import progressive from '../assets/images/Vectorprogressive.png'
import Passwordless from '../assets/images/Vectorpasswordless.png'

import sso from '../assets/images/Vectorsso.png'
import mfa from '../assets/images/Vectormfa.png'
import network from '../assets/images/Vectornetwork.png'
import lifecycle from '../assets/images/Vectorlifecycle.png'
import vpn from '../assets/images/Vectorvpn.png'
import brokering from '../assets/images/Vectorbrokering.png'
import adaptive from '../assets/images/Vectoradaptive.png'
import YouTube from 'react-youtube';
import { AiFillPieChart, AiOutlineAudit, AiOutlineClockCircle, AiOutlinePieChart } from "react-icons/ai";
import { MdOutlineAppBlocking, MdOutlineFingerprint, MdOutlineVerifiedUser, MdOutlineVideoCameraFront, MdVerifiedUser } from 'react-icons/md';
import { MdDataObject } from 'react-icons/md';
import VideoEmbed from '../components/VideoEmbed';


const CasBDemo = () => {

  const [open, setOpen] = useState(false);
  const [demoData, setDemoData] = useState();
  const handleOpen = (videoData) => {
    setDemoData(videoData);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);
  const url = new URL(window.location.href);

  const opts = {
    height: '337',
    width: '600',
    playerVars: {
      //   https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      rel: 0
    },
  };

  const playPause = (event) => {
    event.target.pauseVideo();
  }

  const casbData = [
    {
      title: "Granular Access Control ",
      video: false,
      videoId: "1JB9uwzz1_5GyMZArqB8Xx-8-woZqV5dw",
      videoType: "drive",
      icon: <span class="material-symbols-rounded text-white fs-4">
        grain
      </span>
    },
    {
      title: "Data Protection ",
      video: false,
      videoId: "1NFfKbbjEKqxdH4utIvJAyQc_2nYQdVtQ",
      videoType: "drive",
      icon: <span class="material-symbols-rounded text-white fs-4">
        data_check
      </span>
    },
    {
      title: "Network-based Restrictions ",
      video: false,
      videoId: "1KfwPq7T34KJfHWIjCHgMsAxxWeKbCF2E",
      videoType: "drive",
      icon: <span class="material-symbols-rounded text-white fs-4">
        router
      </span>
    },
    {
      title: "Shadow IT Detection ",
      video: false,
      videoId: "1430g7l00Gc1ctRjy1A_PLXs6FuOGeP3U",
      videoType: "drive",
      icon: <span class="material-symbols-rounded text-white fs-4">
        detection_and_zone
      </span>
    },
    {
      title: "Enable Device Restrictions ",
      video: false,
      videoId: "19Dhvj7tYUCP-sjIFoIgGwqVVBqqbr-MD",
      videoType: "drive",
      icon: <span class="material-symbols-rounded text-white fs-4">
        phonelink_erase
      </span>
    }
  ]

  return (
    <>
      <div className='w-100 py-3' style={{ height: '91vh' }}>
        <div className='mx-2 h-auto'>
          <div className='backButton d-flex align-items-center' onClick={()=>window.location.href = `${url.origin}/demo`}>
            <span class="material-symbols-rounded text-dark">
              keyboard_arrow_left
            </span>
            <p className='mb-0'>Back to main page</p>
          </div>
        </div>

        <h4 className='text-center mt-3 h-auto lh-base text-secondary-emphasis fw-bold'>Cloud Access Security Broker</h4>
        <h5 className='text-center mb-3 h-auto text-secondary'>Break Down Barriers, Take Command of the Cloud</h5>
        <div className='row justify-content-center h-75 align-items-center mx-5'>
          <div className='col-10'>
            <div className='row'>
              <div className='col-6 d-flex align-items-center justify-content-end'>
              <YouTube videoId="pC1lUsMf3wY?si=fD_7TgosWnHUABlL" opts={opts} onReady={playPause} />
              </div>
              <div className='col-6 d-flex justify-content-center'>
                <div className='d-flex flex-column'>

                  {casbData.map((item) => {
                    if (item.video == false) {
                      return (
                        <div className=' p-2 mb-3 d-flex align-items-center ' style={{ width: 'fit-content' }}>

                          <div className='d-flex justify-content-center align-items-center me-2' style={{ height: '40px', width: '40px', borderRadius: '50px', background: '#eb5424' }}>
                            {/* <img src={sso} style={{width:'15px'}}/> */}
                            {item.icon}
                          </div>
                          <p className='mb-0 me-2'>{item.title}</p>

                        </div>
                      )
                    }
                    else {
                      return (
                        <div className=' p-2 mb-3 d-flex align-items-center service-button' onClick={() => handleOpen({ "text": item.title, "videoId": item.videoId, "videoType": item.videoType })} style={{ width: 'fit-content' }}>

                          <div className='d-flex justify-content-center align-items-center me-2' style={{ height: '40px', width: '40px', borderRadius: '50px', background: '#eb5424' }}>
                            {/* <img src={sso} style={{width:'15px'}}/> */}
                            {item.icon}
                          </div>
                          <p className='mb-0 me-2'>{item.title}</p>

                        </div>
                      )
                    }
                  })}

                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      <VideoModal
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        videoData={demoData}
      />
    </>
  )
}

export default CasBDemo